var render = function render(){var _vm=this,_c=_vm._self._c;return _c('timer',{attrs:{"color":_vm.color,"time":_vm.duration - (_vm.ghost ? _vm.ghost : _vm.playtime),"aria-label":_vm.a11y.current,"tabindex":"0","remaining":true,"data-test":"timer-duration"}})
}
var staticRenderFns = []

export { render, staticRenderFns }